import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private achievementsData = [

  ];

  private newsData = [

  ];

  constructor() { }

  getItemById(id: number, category: string) {
    let data;
    if (category === 'news') {
      data = this.newsData;
    } else if (category === 'achievement') {
      data = this.achievementsData;
    }
    if (data) {
      const item = data.find((item) => item.id === +id);
      console.log('fetched item:', item);
      return of(item);
    } else {
      console.error(`Data for category ${category} is not defined`);
      return of(null);
    }
  }
}
